"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullscreenControl = void 0;
var _uiKit = require("@cian/ui-kit");
var _ControlButton = require("../ControlButton");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./FullscreenControl.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const FullscreenControl = _ref => {
  let {
    isFullscreen,
    onToggle
  } = _ref;
  return /*#__PURE__*/React.createElement(_ControlButton.ControlButton, {
    onClick: onToggle,
    className: styles['fullscreen-button']
  }, isFullscreen ? /*#__PURE__*/React.createElement(_uiKit.IconClose16, {
    color: "primary_100",
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"
  }) : /*#__PURE__*/React.createElement(_uiKit.IconFullscreen16, {
    color: "primary_100",
    "aria-label": "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C \u043D\u0430 \u043F\u043E\u043B\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D"
  }));
};
exports.FullscreenControl = FullscreenControl;